import { NavigationGuardNext, RouteConfig, Route } from 'vue-router';
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { staffPermissions } from './permissions';
import { checkPermissions } from '../routeValidation';
import { NAVBAR_TYPE_LIGHT } from '@/util/constants/config';
import { ROUTES } from './routes';

const { STAFF_HOME, } = ROUTES;

const StaffHome = () =>
  import(
    /* webpackChunkName: "StaffHome" */
    '@/views/Staff/Home.vue'
  );

const transactionHistoryRoute: RouteConfig = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: STAFF_HOME.route,
      name: STAFF_HOME.name,
      component: StaffHome,
      beforeEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        checkPermissions(to, from, next);
      },
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: staffPermissions,
      },
    }
  ],
};
export default transactionHistoryRoute;
